export class DeleteCloudEnvironmentResponse {
    environmentId?: string;
}